import { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../footer";
import CourseHeader from "../header";
import CourseServices from '../../../services/CourseServices';
import {showsuccessAlert} from '../../../services/AlertService';

const AddCourse = () => {
  const [form, setForm] = useState({ title: '', description: '', video: [], image: {}, price: '' });
  const [selectedImage, setSelectedImage] = useState(null);
  const [mediaInputs, setMediaInputs] = useState([
    { id: Date.now(), videoURL: '' },
  ]);

  const addMediaInput = () => {
    setMediaInputs([
        ...mediaInputs,
        { id: Date.now(), videoURL: '' },
    ]);
  };

  const removeMediaInput = (id) => {
    setMediaInputs((prev) => prev.filter((input) => input.id !== id));
    setForm((prevForm) => ({
      ...prevForm,
      video: prevForm.video.filter((v) => v.id !== id),
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setForm({ ...form, image: file });

      const reader = new FileReader();
      reader.onloadend = () => {
          setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const updateVideoInput = (id, value) => {
    const updatedMediaInputs = mediaInputs.map((media) =>
        media.id === id ? { ...media, videoURL: value } : media
    );
    setMediaInputs(updatedMediaInputs);

    setForm((prevForm) => ({
        ...prevForm,
        video: updatedMediaInputs,
    }));
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('title', form.title);
    formData.append('description', form.description);
    formData.append('price', form.price);
    formData.append('image', form.image);
    formData.append('video', JSON.stringify(form.video));
    
    try {
      const response = await CourseServices.courseadd(formData);
      showsuccessAlert('Course added successfully!');
      console.log(response);
    } catch (error) {
      console.error('Error submitting course:', error);
      // alert('Failed to add course. Please try again.');
    }
  };

  return (
    <>
      <div className="main-wrapper">
        <CourseHeader activeMenu={"AddCourse"} />

        <section className="page-content course-sec">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="add-course-header">
                  <h2>Add New Course</h2>
                  <div className="add-course-btns">
                    <ul className="nav">
                      <li>
                        <Link
                          to="/admin/admin-courses"
                          className="btn btn-black"
                        >
                          Back to Course
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="widget-set">
                    <div className="widget-content multistep-form">
                      <form onSubmit={handleSubmit}>
                        <fieldset className="field-card" style={{display:"block"}}>
                          <div className="add-course-info">
                            <div className="add-course-inner-header">
                              <h4>Basic Information</h4>
                            </div>
                            <div className="add-course-form">
                              <form action="#">
                                <div className="input-block">
                                  <label className="add-course-label">Course Title</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Course Title"
                                    onChange={(e) => setForm({ ...form, title: e.target.value })}
                                  />
                                </div>
                                <div className="input-block">
                                  <label className="add-course-label">Course Description</label>
                                  <textarea
                                    rows={10}
                                    className="form-control"
                                    placeholder="Course Description"
                                    onChange={(e) => setForm({ ...form, description: e.target.value })}
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className="add-course-info">
                            <div className="add-course-inner-header">
                              <h4>Courses Media</h4>
                            </div>
                            <div className="add-course-form">
                                <div className="input-block">
                                  <label className="add-course-label">Course cover image</label>
                                  <div className="relative-form">
                                    <label className="relative-file-upload">
                                      Upload File 
                                      <input
                                      type="file"
                                      onChange={handleFileChange}
                                      />
                                    </label>
                                  </div>
                                </div>
                                <div className="input-block">
                                  <div className="add-image-box">
                                    {selectedImage ? (
                                        <img
                                            src={selectedImage}
                                            alt="Selected Preview"
                                        />
                                    ) : (
                                        <p>No Image Selected</p>
                                    )}
                                  </div>
                                </div>
                                {mediaInputs.map((media) => (
                                <div key={media.id} className="media-input">
                                  <div className="input-block">
                                    <div className="removevideo-form">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Video URL"
                                        value={media.videoURL}
                                        onChange={(e) => updateVideoInput(media.id, e.target.value)}
                                      />
                                      <button
                                        className="btn btn-danger relative-file-upload"
                                        onClick={() => removeMediaInput(media.id)}
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                                <button type="button" className="btn btn-primary" onClick={addMediaInput}>
                                    + Add More Video
                                </button>
                                <div className="input-block mb-0 mt-3">
                                  <label className="add-course-label">Price</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder={10.0}
                                    onChange={(e) => setForm({ ...form, price: e.target.value })}
                                  />
                                </div>
                            </div>
                            <div className="widget-btn">
                              <button type="submit" className="btn btn-info-light next_btn">Save</button>
                            </div>
                          </div>
                        </fieldset>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default AddCourse;
